module.exports = __webpack_public_path__ + "static/img/msg2.e96fd96e.svg";